<p-input-number :placeholder="name" v-model="model" mode="decimal"> </p-input-number>